import { inject, Injectable } from '@angular/core';
import { defer, Observable } from 'rxjs';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { map } from 'rxjs/operators';
import { AccountCategory } from '../../models/account-category.schema';
import { PhoneNumberValue } from '../../shared/phone-number/phone-number.component';
import { AccountScope, AccountV2 } from '../../models/account';
import { Location } from '../../models/location';

export interface UpdateAccountPayload {
  id: string,
  name: string,
  accountGoal: string,
  addressDetails: Location,
  accountCategory: AccountCategory | null,
  phone: PhoneNumberValue | null,
  extension: string,
  scope: AccountScope,
  userIds: string[],
  website: string,
  tags: string[],
  source: string,
  reference: string,
  primaryUserId?: string | null,
}

@Injectable({
  providedIn: 'root',
})
export class updateAccountService {
  private readonly functions = inject(Functions);

  update(payload: UpdateAccountPayload): Observable<AccountV2> {
    return defer(() =>
      httpsCallable<UpdateAccountPayload, AccountV2>(this.functions, 'updateAccountV2')(payload)
    ).pipe(
      map(response => response.data),
    );
  }
}
